<template>
  <!-- eslint-disable -->
  <div v-if="prestador.id != 16" style="text-align:left; background-color: #fafbfc;">


    <div class="column-left">
      <SideNav />
    </div>


    <div class="column-right">
      <TopNav />
      <div class="main-container">

        <div v-if="true" class="articulo-principal">
          <div class="welcome-header">
            <div class="welcome-icon">
              <svg width="32" height="32" viewBox="0 0 419 419" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0 0 C1.15739182 -0.01429047 1.15739182 -0.01429047 2.33816528 -0.02886963 C3.96351695 -0.04098395 5.58900987 -0.04024588 7.21435547 -0.02734375 C9.68320565 -0.01568219 12.14518002 -0.06788854 14.61328125 -0.125 C27.7726158 -0.23717191 27.7726158 -0.23717191 32.7734375 4 C34.49365234 5.92089844 34.49365234 5.92089844 35.8203125 7.734375 C36.71363281 8.92546875 36.71363281 8.92546875 37.625 10.140625 C43.65670676 21.93987618 43.26656742 31.35186504 41.16796875 44.14160156 C40.99240448 45.24679138 40.81684021 46.3519812 40.63595581 47.49066162 C40.05794191 51.11982413 39.47028341 54.7473575 38.8828125 58.375 C38.47852934 60.9059522 38.07497579 63.43702104 37.67211914 65.96820068 C36.72074348 71.93740689 35.76374311 77.90568104 34.80342579 83.8734529 C32.98054307 95.2015447 31.16652951 106.53104077 29.35958862 117.86168671 C28.76486105 121.58092065 28.16500699 125.29930269 27.56469727 129.01763916 C27.20049626 131.29330499 26.83647293 133.56899926 26.47265625 135.84472656 C26.22018631 137.39552917 26.22018631 137.39552917 25.96261597 138.97766113 C25.73543381 140.4072818 25.73543381 140.4072818 25.50366211 141.86578369 C25.37092392 142.69016056 25.23818573 143.51453743 25.10142517 144.36389542 C24.80750755 146.84235263 24.77181156 149.24091299 24.8203125 151.734375 C25.94824219 151.28707031 27.07617188 150.83976563 28.23828125 150.37890625 C40.22903135 145.73037908 52.20823085 142.2474452 64.8203125 139.734375 C66.06039062 139.486875 67.30046875 139.239375 68.578125 138.984375 C101.90058825 133.71136983 139.06569681 137.14116219 167.43359375 156.51953125 C169.63386641 158.18778634 171.72816109 159.93313226 173.8203125 161.734375 C174.58988281 162.33765625 175.35945313 162.9409375 176.15234375 163.5625 C182.77822043 168.96868794 188.33289868 176.0817849 189.8203125 184.734375 C190.70143117 196.88225694 189.70318415 206.5718623 181.5703125 216.109375 C173.41128679 224.5217038 164.71199909 228.78650317 152.9453125 229.171875 C142.12295106 228.89228762 133.58294774 225.30368791 125.8203125 217.734375 C124.66501644 216.25758253 123.53979041 214.75678858 122.4453125 213.234375 C116.71741279 205.46458511 108.07628764 201.00470852 98.8203125 198.734375 C98.09585937 198.55132812 97.37140625 198.36828125 96.625 198.1796875 C77.22033498 195.09872397 58.67967592 199.72320013 42.6875 210.9296875 C39.68710036 213.30026564 36.81283089 215.68500592 34.18359375 218.46484375 C32.8203125 219.734375 32.8203125 219.734375 30.8203125 219.734375 C30.56507813 220.30414063 30.30984375 220.87390625 30.046875 221.4609375 C28.68256895 223.98968311 27.06421505 225.92774772 25.1953125 228.109375 C7.00095777 250.6215929 -0.67203973 280.14353443 1.8203125 308.734375 C3.88007612 325.68243002 11.03081053 340.65860267 24.23046875 351.76171875 C37.79311858 361.92833265 54.14293757 363.95070984 70.5703125 362.046875 C86.63415811 359.58617805 101.64480359 352.03710371 111.83203125 339.19921875 C116.59502993 332.18386928 119.27668756 324.76379013 121.8203125 316.734375 C121.18528809 316.75008545 120.55026367 316.7657959 119.89599609 316.78198242 C116.9958602 316.8446609 114.09586726 316.88346917 111.1953125 316.921875 C109.69677734 316.95958008 109.69677734 316.95958008 108.16796875 316.99804688 C101.02033202 317.06904989 96.63224771 316.219341 91.1328125 311.359375 C86.20468495 305.76528427 84.65755352 301.17788568 84.8203125 293.734375 C86.32290896 284.19361689 91.42713619 275.96840699 98.984375 270.01171875 C109.80792601 262.48129071 121.80000999 262.42939338 134.61328125 262.46875 C136.01329109 262.46739868 137.41330046 262.46545428 138.81330872 262.46295166 C141.72706635 262.46002526 144.64070025 262.46421904 147.55444336 262.47363281 C151.26956304 262.48505799 154.98439461 262.47843284 158.6995039 262.46648788 C161.58301428 262.45922888 164.46645735 262.46157512 167.34996986 262.46674347 C168.71936389 262.46806716 170.08876424 262.46647773 171.45815086 262.46178436 C191.27884884 262.40870806 191.27884884 262.40870806 198.8203125 268.734375 C204.5810215 275.77956641 206.57566668 281.71141985 205.8203125 290.734375 C205.07359157 294.55928487 204.01257246 298.25653217 202.8828125 301.984375 C202.57069824 303.02779053 202.25858398 304.07120605 201.93701172 305.14624023 C193.6211161 332.08215619 180.25638464 354.38594101 160.8203125 374.734375 C159.60021484 376.03375 159.60021484 376.03375 158.35546875 377.359375 C132.18230776 404.50819677 93.83798162 419.08579725 56.41015625 419.90234375 C23.88139085 420.16490266 -8.7374541 414.51552199 -34.1796875 392.734375 C-35.41138672 391.70183594 -35.41138672 391.70183594 -36.66796875 390.6484375 C-42.61419909 385.50526407 -47.47780067 380.01757619 -52.1796875 373.734375 C-53.10543949 372.50128012 -54.0312229 371.26820882 -54.95703125 370.03515625 C-56.49031529 367.99019371 -58.02216329 365.94420538 -59.55078125 363.89575195 C-63.70278575 358.33920218 -67.9610368 352.87535115 -72.26171875 347.43359375 C-80.44893582 337.07292949 -88.51375487 326.61499777 -96.5546875 316.140625 C-99.74596725 311.99196132 -102.9639005 307.86405019 -106.1796875 303.734375 C-110.19434375 298.57880148 -114.20069773 293.41753272 -118.1796875 288.234375 C-132.9804596 268.95524162 -132.9804596 268.95524162 -148.234375 250.03515625 C-173.01137463 219.97567714 -173.01137463 219.97567714 -171.1796875 199.734375 C-168.89010389 191.14843646 -162.56889644 182.78575149 -154.9921875 178.171875 C-144.99999859 172.73186262 -135.98511281 171.56683053 -124.96875 174.7265625 C-113.8162422 178.75646028 -107.2199063 187.42595523 -100.40234375 196.7109375 C-97.40890836 200.78285138 -94.29641839 204.7567467 -91.1796875 208.734375 C-93.52399207 198.72975616 -96.46741352 188.94350383 -99.4765625 179.125 C-99.99389447 177.42853887 -100.51091677 175.73198328 -101.02764893 174.03533936 C-102.38361014 169.58542404 -103.74288239 165.13652798 -105.10314941 160.68792725 C-106.46329973 156.23896416 -107.82170663 151.78946945 -109.1796875 147.33984375 C-109.44430031 146.47282585 -109.70891312 145.60580795 -109.98154449 144.71251678 C-112.03847636 137.97000419 -114.08806479 131.22527941 -116.13204193 124.47882843 C-117.20786097 120.9292323 -118.28648243 117.38063143 -119.37915039 113.83618164 C-120.39092185 110.55013079 -121.38885078 107.26022218 -122.3828125 103.96875 C-122.66131042 103.07907532 -122.93980835 102.18940063 -123.22674561 101.27276611 C-126.32167848 90.89116232 -127.70903491 80.2327918 -122.98828125 70.203125 C-117.88862069 60.97649119 -110.48138453 54.35969799 -100.3515625 51.15625 C-89.24606521 48.99906707 -79.56523752 51.08216873 -70.08984375 57.05078125 C-61.22460624 63.85974923 -57.86467395 74.67875791 -54.8671875 84.984375 C-54.29626456 86.8820282 -53.72533989 88.77968088 -53.15432739 90.67730713 C-52.3575607 93.33804882 -51.5736882 96.00252423 -50.78948975 98.66699219 C-49.33652786 103.59289799 -47.8621747 108.51245906 -46.38989258 113.43261719 C-45.59072971 116.10339735 -44.79812481 118.7759917 -44.01049805 121.45019531 C-43.65383057 122.65256836 -43.29716309 123.85494141 -42.9296875 125.09375 C-42.61515625 126.16077148 -42.300625 127.22779297 -41.9765625 128.32714844 C-41.40444954 130.65930111 -41.40444954 130.65930111 -40.1796875 131.734375 C-40.05241539 130.91329726 -40.05241539 130.91329726 -39.92257214 130.0756321 C-37.85164218 116.71853818 -35.77279525 103.3626969 -33.68554974 90.00814247 C-32.67638471 83.54978125 -31.66980242 77.09103986 -30.66918945 70.63134766 C-29.70274327 64.39286313 -28.72942558 58.15548555 -27.75141335 51.91880417 C-27.38020719 49.54386612 -27.01144324 47.16854497 -26.64520836 44.79283524 C-26.13028 41.45539487 -25.60654131 38.11944479 -25.08081055 34.78369141 C-24.93263382 33.8097644 -24.78445709 32.8358374 -24.63179016 31.83239746 C-22.68175 19.6089164 -19.82880939 9.94327957 -9.957901 1.83003235 C-6.84823987 -0.08600477 -3.53825952 -0.01861088 0 0 Z"
                  :fill="prestador.admin.assets.colors.primary" transform="translate(191.1796875,-0.734375)" />
              </svg>
            </div>
            <h1 class="welcome-title">Bienvenido a ClinicGo</h1>
            <p class="welcome-subtitle">Panel de administración médica</p>
          </div>

          <!-- <div class="info-banner">
            <div class="info-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="16" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12.01" y2="8"></line>
              </svg>
            </div>
            <div class="info-content">
              <p><strong>Mantención de servicios:</strong>
                Hoy a las 23:00 horas se realizará una mantención del servicio, por lo que se detendrá su funcionamiento
                temporalmente.
              </p>
            </div>
          </div> -->

          <div class="content-card">
            <div class="card-header">
              <div class="greeting-section">
                <h2 class="greeting-title">¡Muy buenos días!
                  <span class="greeting-emoji">🎉</span>
                </h2>
                <p class="greeting-description">
                  Desde aquí, tendrás el control total y una visión clara de todas las operaciones críticas que
                  mantienen a nuestra empresa a la vanguardia en servicios de exámenes de laboratorio a domicilio.
                </p>
              </div>
            </div>

            <div class="features-section">
              <h3 class="features-title">¿Qué puedes hacer desde este panel?</h3>

              <div class="features-grid">
                <div class="feature-card">
                  <div class="feature-icon medical-staff">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
                        fill="currentColor" />
                    </svg>
                  </div>
                  <div class="feature-content">
                    <h4 class="feature-title">Gestión de Tomadores de Muestra</h4>
                    <p class="feature-description">Accede a los perfiles de todos nuestros especialistas, actualiza su
                      información y asegúrate de que cuenten con todo lo necesario para brindar un servicio excepcional.
                    </p>
                  </div>
                </div>

                <div class="feature-card">
                  <div class="feature-icon orders">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z"
                        fill="currentColor" />
                    </svg>
                  </div>
                  <div class="feature-content">
                    <h4 class="feature-title">Manejo de Órdenes</h4>
                    <p class="feature-description">Monitoriza, actualiza y organiza todas las solicitudes de servicios.
                      Desde confirmar citas hasta revisar detalles específicos de cada orden.</p>
                  </div>
                </div>

                <div class="feature-card">
                  <div class="feature-icon schedule">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V8H19V19ZM7 10H12V15H7V10Z"
                        fill="currentColor" />
                    </svg>
                  </div>
                  <div class="feature-content">
                    <h4 class="feature-title">Horarios de los Tomadores</h4>
                    <p class="feature-description">Planifica y visualiza las agendas de nuestros especialistas.
                      Asegúrate de que los horarios sean óptimos para maximizar la eficiencia.</p>
                  </div>
                </div>

                <div class="feature-card">
                  <div class="feature-icon analytics">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.5 18.49L9 12.99L13 16.99L22 6.92L20.59 5.51L13 13.1L9 9.1L2.09 17.01L3.5 18.49Z"
                        fill="currentColor" />
                    </svg>
                  </div>
                  <div class="feature-content">
                    <h4 class="feature-title">Reportes y Analíticas</h4>
                    <p class="feature-description">Obtén insights valiosos a través de nuestra sección de reportería.
                      Conoce las tendencias y áreas de oportunidad.</p>
                  </div>
                </div>

                <div class="feature-card">
                  <div class="feature-icon pricing">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M11.8 10.9C9.53 10.31 8.8 9.7 8.8 8.75C8.8 7.66 9.81 6.9 11.5 6.9C13.28 6.9 13.94 7.75 14 9H16.21C16.14 7.28 15.09 5.7 13 5.19V3H10V5.16C8.06 5.58 6.5 6.84 6.5 8.77C6.5 11.08 8.41 12.23 11.2 12.9C13.7 13.5 14.2 14.38 14.2 15.31C14.2 16 13.71 17.1 11.5 17.1C9.44 17.1 8.63 16.18 8.5 15H6.32C6.44 17.19 8.08 18.42 10 18.83V21H13V18.85C14.95 18.5 16.5 17.35 16.5 15.3C16.5 12.46 14.07 11.5 11.8 10.9Z"
                        fill="currentColor" />
                    </svg>
                  </div>
                  <div class="feature-content">
                    <h4 class="feature-title">Precios y Tarifarios</h4>
                    <p class="feature-description">Gestiona y actualiza la estructura de precios de nuestros servicios.
                      Mantente al tanto de las promociones.</p>
                  </div>
                </div>

                <div class="feature-card">
                  <div class="feature-icon tools">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M22.7 19L13.6 9.9C14.5 7.6 14 4.9 12.1 3C10.1 1 7.1 1.6 5.1 3.6L8.5 7L7 8.5L3.6 5.1C1.6 7.1 1 10.1 3 12.1C4.9 14 7.6 14.5 9.9 13.6L19 22.7C19.3 23 19.7 23 20 22.7L22.6 20.1C23 19.7 23 19.3 22.7 19Z"
                        fill="currentColor" />
                    </svg>
                  </div>
                  <div class="feature-content">
                    <h4 class="feature-title">Y mucho más...</h4>
                    <p class="feature-description">Explora todas las herramientas y secciones que hemos diseñado para
                      hacer de la administración una experiencia intuitiva y poderosa.</p>
                  </div>
                  <div class="feature-content">
                    <h4 class="feature-title">Enviar Ticket a soporte</h4>
                    <a href="https://tally.so/r/mVaK5g" target="_blank" class="btn-soporte">Enviar ahora</a>
                  </div>
                </div>
              </div>
            </div>

            <div class="footer-section">
              <div class="commitment-card">
                <div class="commitment-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12 21.35L10.55 20.03C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 12.27 18.6 15.36 13.45 20.03L12 21.35Z"
                      fill="#10b981" />
                  </svg>
                </div>
                <div class="commitment-content">
                  <p class="commitment-text">
                    Estamos comprometidos con la excelencia y con brindar el mejor servicio posible. Tu rol es esencial
                    para garantizar que sigamos siendo líderes en el mercado.
                  </p>
                  <div class="signature">
                    <p class="signature-text">Un saludo,</p>
                    <p class="signature-team"><strong>Equipo de ClinicGo</strong></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
  <div v-else>
    <InicioUcEnCasa/>
  </div>
</template>

<script>
/* eslint-disable */

import { mapGetters, mapActions } from 'vuex';
import SideNav from '@/components/SideNav.vue';
import Loader from '@/components/Loader.vue';
import TopNav from '@/components/TopNav.vue';
import InicioUcEnCasa from './InicioUcEnCasa.vue';

export default {
  name: 'HelloWorld',
  props: ['id'],
  components: {
    SideNav,
    Loader,
    TopNav,
    InicioUcEnCasa
  },
  data() {
    return {


    }
  },
  created() {


  },

  methods: {
    ...mapActions(['initialize']),



  },
  computed: {
    ...mapGetters(['comunas', 'categorias', 'regiones', 'prestaciones', 'tipos', 'admin_datos', 'prestador']),
  },



}
</script>


<style scoped>
/* Variables CSS para consistencia */
:root {
  --primary-color: #0ea5e9;
  --primary-light: #e0f2fe;
  --secondary-color: #10b981;
  --secondary-light: #d1fae5;
  --accent-color: #8b5cf6;
  --text-primary: #1e293b;
  --text-secondary: #64748b;
  --text-muted: #94a3b8;
  --background-primary: #fafbfc;
  --background-secondary: #ffffff;
  --border-color: #e2e8f0;
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --radius-sm: 6px;
  --radius-md: 8px;
  --radius-lg: 12px;
  --radius-xl: 16px;
}

.info-banner {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.5rem;
  background: #f0f9ff;
  border-radius: 12px;
  margin-bottom: 1.5rem;
  border: 1px solid #bae6fd;
}

.info-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #0ea5e9, #0284c7);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
}

.info-content p {
  color: #0c4a6e;
  font-size: 0.875rem;
  margin: 0;
  line-height: 1.5;
}


.btn-soporte {
  display: inline-block;
  background-color: #007BFF;
  color: white;
  padding: 12px 24px;
  border-radius: 6px;
  text-decoration: none;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.btn-soporte:hover {
  background-color: #0056b3;
}

/* Reset y base */
* {
  box-sizing: border-box;
}

td {
  text-align: left;
}

table {
  margin-left: auto;
  margin-right: auto;
}

/* Layout principal */
.column-right {
  background-color: var(--background-primary);
  padding-top: 0px;
  padding-left: 275px;
  width: 100%;
  min-height: 100vh;
}

.main-container {
  background-color: var(--background-primary);
  padding: 24px;
  margin-top: 10px;
}

.articulo-principal {
  min-height: calc(100vh - 120px);
  max-width: 1200px;
  margin: 0 auto;
}

/* Header de bienvenida */
.welcome-header {
  text-align: center;
  margin-bottom: 32px;
  padding: 24px 0;
}

.welcome-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, var(--primary-light) 0%, var(--secondary-light) 100%);
  border-radius: 50%;
  margin-bottom: 16px;
}

.welcome-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 8px 0;
  letter-spacing: -0.025em;
}

.welcome-subtitle {
  font-size: 1.125rem;
  color: var(--text-secondary);
  margin: 0;
  font-weight: 500;
}

/* Card principal */
.content-card {
  background-color: var(--background-secondary);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-color);
  overflow: hidden;
}

.card-header {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
  padding: 32px;
  color: white;
}

.greeting-section {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}

.greeting-title {
  font-size: 1.875rem;
  font-weight: 700;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.greeting-emoji {
  font-size: 2rem;
}

.greeting-description {
  font-size: 1.125rem;
  line-height: 1.7;
  margin: 0;
  opacity: 0.95;
  font-weight: 400;
  color: #1e293b;
}

/* Sección de características */
.features-section {
  padding: 40px 32px;
}

.features-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 32px 0;
  text-align: center;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 24px;
  max-width: 1000px;
  margin: 0 auto;
}

.feature-card {
  display: flex;
  gap: 16px;
  padding: 24px;
  background-color: var(--background-primary);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-color);
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
}

.feature-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
  border-color: var(--primary-color);
}

.feature-card:hover::before {
  transform: scaleX(1);
}

.feature-icon {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
}

.feature-icon.medical-staff {
  background: linear-gradient(135deg, #0ea5e9, #0284c7);
}

.feature-icon.orders {
  background: linear-gradient(135deg, #10b981, #059669);
}

.feature-icon.schedule {
  background: linear-gradient(135deg, #8b5cf6, #7c3aed);
}

.feature-icon.analytics {
  background: linear-gradient(135deg, #f59e0b, #d97706);
}

.feature-icon.pricing {
  background: linear-gradient(135deg, #ef4444, #dc2626);
}

.feature-icon.tools {
  background: linear-gradient(135deg, #6366f1, #4f46e5);
}

.feature-content {
  flex: 1;
}

.feature-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 8px 0;
  line-height: 1.4;
}

.feature-description {
  font-size: 0.875rem;
  color: var(--text-secondary);
  line-height: 1.6;
  margin: 0;
}

/* Sección footer */
.footer-section {
  background-color: var(--background-primary);
  padding: 32px;
  border-top: 1px solid var(--border-color);
}

.commitment-card {
  max-width: 700px;
  margin: 0 auto;
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.commitment-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--secondary-light);
  display: flex;
  align-items: center;
  justify-content: center;
}

.commitment-content {
  flex: 1;
}

.commitment-text {
  font-size: 1rem;
  color: var(--text-secondary);
  line-height: 1.6;
  margin: 0 0 16px 0;
}

.signature {
  margin-top: 16px;
}

.signature-text {
  font-size: 0.875rem;
  color: var(--text-muted);
  margin: 0 0 4px 0;
}

.signature-team {
  font-size: 0.875rem;
  color: var(--text-primary);
  margin: 0;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .features-grid {
    grid-template-columns: 1fr;
  }

  .welcome-title {
    font-size: 2rem;
  }
}

@media (max-width: 1200px) {
  .column-right {
    padding-left: 0px;  
  }

  .main-container {
    padding: 16px;
  }

  .welcome-title {
    font-size: 1.75rem;
  }

  .welcome-subtitle {
    font-size: 1rem;
  }

  .card-header {
    padding: 24px 20px;
  }

  .features-section {
    padding: 32px 20px;
  }

  .footer-section {
    padding: 24px 20px;
  }

  .greeting-title {
    font-size: 1.5rem;
    flex-direction: column;
    gap: 4px;
  }

  .greeting-description {
    font-size: 1rem;
  }

  .features-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .feature-card {
    padding: 20px;
  }

  .commitment-card {
    flex-direction: column;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .welcome-header {
    padding: 16px 0;
    margin-bottom: 24px;
  }

  .welcome-title {
    font-size: 1.5rem;
  }

  .card-header {
    padding: 20px 16px;
  }

  .features-section {
    padding: 24px 16px;
  }

  .footer-section {
    padding: 20px 16px;
  }

  .feature-card {
    padding: 16px;
    gap: 12px;
  }

  .feature-icon {
    width: 40px;
    height: 40px;
  }

  .greeting-title {
    font-size: 1.25rem;
  }

  .greeting-description {
    font-size: 0.9rem;
  }
}

/* Animaciones suaves */
@media (prefers-reduced-motion: no-preference) {

  .feature-card,
  .commitment-card {
    transition: all 0.2s ease;
  }

  .feature-icon {
    transition: transform 0.2s ease;
  }

  .feature-card:hover .feature-icon {
    transform: scale(1.05);
  }
}

/* Modo oscuro (opcional para futuras implementaciones) */
@media (prefers-color-scheme: dark) {
  :root {
    --text-primary: #f1f5f9;
    --text-secondary: #cbd5e1;
    --text-muted: #94a3b8;
    --background-primary: #0f172a;
    --background-secondary: #1e293b;
    --border-color: #334155;
  }
}
</style>